import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { actions as userActions } from 'builder/modules/user'
import { actions as panelActions } from 'builder/modules/panel'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'

export const useAiResumeReviewHighlightState = () => {
  const dispatch = useDispatch()
  const isAiResumeReviewSwitcherSeen = useTypedSelector(
    store => store.user?.data?.uiStates?.aiResumeReviewSwitcherSeen,
  )
  const setIsAiResumeReviewSwitcherSeen = useCallback(
    (value: boolean) => {
      dispatch(userActions.setUIUserState({ aiResumeReviewSwitcherSeen: value }))
      dispatch(panelActions.setUIStatesConfigStatus({ ai_resume_review_switcher_seen: value }))
    },
    [dispatch],
  )

  return {
    isAiResumeReviewSwitcherSeen,
    setIsAiResumeReviewSwitcherSeen,
  }
}
